onComplete(function () {
	// Add code here.
	const isMobile = window.matchMedia("(max-width: 991px)").matches;

	window.addEventListener('scroll', () => {
		const scroll = window.pageYOffset || document.documentElement.scrollTop;
		const navHeader = document.querySelectorAll('.nav-header');

		if (scroll >= 75) {
			navHeader.forEach(el => el.classList.add('scroll'));
		} if (scroll <= 25) {
			navHeader.forEach(el => el.classList.remove('scroll'));
		}
	})

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.setAttribute('data-in-view', '');
			} else {
				entry.target.removeAttribute('data-in-view', '');
			}
		});
	});

	const elementsToFadeIn = document.querySelectorAll('.tekst-op-foto-large, .tekst-op-foto, .vacature-overzicht');
	elementsToFadeIn.forEach(element => observer.observe(element));
});